import React from 'react'
import { useSelector } from 'react-redux'
import { areIntervalsOverlapping } from 'date-fns'

import { rightSelector } from '../../../../../../../../modules/selectors/rights'
import { lineItemsSelector } from '../../../../../../../../modules/selectors/lineItems'

import { getInventoryDisplayName } from '../../../validation/helpers/messageHelpers'
import { getLineItemTargetedInventory } from '../../../validation/helpers/lineItemHelpers'

import { END_DATE, START_DATE } from '../../../../../../../ReusableFormFields/StartEndDateRangeFields/fields'

const getAvailableInventory = (allPlacements, conflictingPlacementIds) => {
  return allPlacements.filter(placement => !conflictingPlacementIds.includes(placement.placement_id))
}

const SelectDifferentInventoryValidationMessage = ({ formValues }) => {
  const right = useSelector(rightSelector)
  const lineItems = useSelector(lineItemsSelector)

  // Calculate available inventory only when showing this message
  const availableInventory = React.useMemo(() => {
    const startDate = formValues[START_DATE]
    const endDate = formValues[END_DATE]

    const lineItemsThatOverlapWithSelectedDates = lineItems.filter(lineItem => {
      const datesOverlap = areIntervalsOverlapping(
        { start: new Date(startDate), end: new Date(endDate) },
        { start: new Date(lineItem.date_start), end: new Date(lineItem.date_stop) }
      )

      return datesOverlap
    })

    const inventoryInOverlappingLineItems = lineItemsThatOverlapWithSelectedDates.reduce((acc, lineItem) => {
      const targetedInventory = getLineItemTargetedInventory(lineItem)
      return [...acc, ...targetedInventory]
    }, [])

    return getAvailableInventory(right?.ad_inventory || [], inventoryInOverlappingLineItems)
  }, [right?.ad_inventory, formValues, lineItems])

  return (
    <>
      <li>
        Only select inventory that is not already targeted by existing line items during the overlapping dates
        {availableInventory?.length > 0 && (
          <>
            :{' '}
            <strong>
              {availableInventory
                .map(inventory =>
                  getInventoryDisplayName(inventory.placement_id || inventory.ad_unit_id, right?.ad_inventory || [])
                )
                .join(', ')}
            </strong>
          </>
        )}
      </li>
    </>
  )
}

export default SelectDifferentInventoryValidationMessage
